import { APIResponse, returnAxios } from 'app/shared/util/class-utils';
import axios from 'axios';

export interface IAccountApi {
  getAuthorizeUrl(): Promise<APIResponse<string>>;
  getCustomer(code: string): Promise<APIResponse<any>>;
}

export class AccountApi implements IAccountApi {
  async getAuthorizeUrl(): Promise<APIResponse<string>> {
    return returnAxios(
      axios.get('api/authorize-url')
    );
  }

  async getCustomer(code: string): Promise<APIResponse<any>> {
    return returnAxios(
      axios.get(`/api/client?code=${encodeURIComponent(code)}`)
    );
  } 
}
